<template>
  <div
    :style="styleMerge"
    class="btnflex button"
  >
    <div class="current-active" />
    <div>{{ viewData.buttonName }}</div>
    <!-- <el-button>{{viewData.buttonName}}</el-button> -->
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpSubdata',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      inputVal: null,
      viewData: {
        margin: [0, 0, 0, 0],
        buttonName: '按钮名称'
      }
    }
  },
  mounted () {
    // console.log('spinput-viewData',this.viewData)
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
.btnflex {
  width: 365px;
  height: 40px;
}
.button {
  width: 100%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  background: #fff;
}
</style>
